import { useaxios } from "../../../utils/useaxios";
export default (user_id, role) => initDispatch => clear => {
    initDispatch({ type: 'loadingTrue' });
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    useaxios('init.php', { user_id, role, today }).then((res) => {
        if (res == "Unauthorized") {
            // clear();
            // return;
        }
        if (res.status == "ok") {
            initDispatch({ type: 'setinit', payload: { user: res.user, role: res.role, expense_type: res.expense_type, active_expense_type: res.active_expense_type, expense: res.expense, category: res.category, unit: res.unit, company: res.company, customer: res.customer, item: res.item, today_invoice: res.today_invoice, return_item_company: res.return_item_company, removeditem: res.removeditem, dollar_price: res.dollar_price, mizania: res.mizania } });
        } else {
            clear();
            // window.location.href = "/nointernet";
            return;
        }
    });

}